/* ==========================================================
   BPP ADVANCED ANIMATIONS
   - Kinetic text (letter split)
   - Morphing blobs
   - Counter increment
   - Shimmer sweep
   - Line draw
   ========================================================== */

(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. KINETIC TEXT ──────────────────────────────────── */
  function initKineticText() {
    var targets = document.querySelectorAll('[data-kinetic]');
    targets.forEach(function (el) {
      var text = el.textContent.trim();
      var mode = el.dataset.kinetic || 'letter'; // 'letter' | 'word'
      var delay = parseFloat(el.dataset.kineticDelay || 0);

      if (prefersReduced) return;

      var parts = mode === 'word' ? text.split(' ') : text.split('');
      el.innerHTML = '';
      el.setAttribute('aria-label', text);

      parts.forEach(function (part, i) {
        var span = document.createElement('span');
        span.className = 'bpp-kinetic-part';
        span.textContent = mode === 'word' ? part + '\u00A0' : (part === ' ' ? '\u00A0' : part);
        span.style.setProperty('--ki', String(i));
        span.style.transitionDelay = (delay + i * (mode === 'word' ? 0.06 : 0.028)) + 's';
        el.appendChild(span);
      });
    });
  }

  /* ── 2. COUNTER ANIMATION ─────────────────────────────── */
  function animateCounter(el) {
    var target = parseFloat(el.dataset.count);
    var suffix = el.dataset.countSuffix || '';
    var prefix = el.dataset.countPrefix || '';
    var duration = 1600;
    var start = null;

    if (prefersReduced) {
      el.textContent = prefix + target + suffix;
      return;
    }

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      var current = Math.round(eased * target);
      el.textContent = prefix + current + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ── 3. LINE DRAW ─────────────────────────────────────── */
  function initLineDraws() {
    document.querySelectorAll('[data-line-draw]').forEach(function (el) {
      el.style.setProperty('--line-progress', '0%');
    });
  }

  /* ── 4. SHIMMER SWEEP on cards ────────────────────────── */
  function addShimmer(el) {
    if (el.querySelector('.bpp-shimmer')) return;
    var shimmer = document.createElement('span');
    shimmer.className = 'bpp-shimmer';
    el.style.position = el.style.position || 'relative';
    el.style.overflow = 'hidden';
    el.appendChild(shimmer);
    setTimeout(function () {
      shimmer.classList.add('bpp-shimmer--run');
      setTimeout(function () { shimmer.remove(); }, 900);
    }, 180);
  }

  /* ── 5. MASTER INTERSECTION OBSERVER ─────────────────── */
  if (typeof IntersectionObserver === 'undefined') return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;

      // Scroll reveal
      if (el.classList.contains('bpp-reveal')) {
        el.classList.add('is-visible');
        // Kinetic: trigger letters
        el.querySelectorAll('.bpp-kinetic-part').forEach(function (part) {
          part.classList.add('is-visible');
        });
      }

      // Kinetic text container
      if (el.classList.contains('bpp-kinetic')) {
        el.querySelectorAll('.bpp-kinetic-part').forEach(function (part) {
          part.classList.add('is-visible');
        });
      }

      // Counter
      if (el.dataset.count) animateCounter(el);

      // Line draw
      if (el.dataset.lineDraw !== undefined) {
        el.style.setProperty('--line-progress', '100%');
      }

      // Shimmer on cards
      if (el.classList.contains('bpp-shimmer-card')) addShimmer(el);

      io.unobserve(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -30px 0px' });

  function observeAll() {
    document.querySelectorAll(
      '.bpp-reveal, .bpp-kinetic, [data-count], [data-line-draw], .bpp-shimmer-card'
    ).forEach(function (el) { io.observe(el); });

    initKineticText();
    initLineDraws();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  /* ── 6. MORPHING BLOBS ────────────────────────────────── */
  /* Pure CSS handled via @keyframes bpp-morph in CSS */

})();
